import { useState } from 'react';
import mainLogo from '../assets/icon-512.webp';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="#" className="navbar-logo">
          <span className="logo-icon"><img src={mainLogo} width={40} height={40} alt="RoomBuddy Logo" className="logo" /></span>
          <span className="logo-text">Room<span className="logo-accent">Buddy</span></span>
        </a>
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span className={`hamburger ${menuOpen ? 'open' : ''}`}></span>
        </button>
        <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          <li><a href="#home" onClick={() => setMenuOpen(false)}>Home</a></li>
          <li><a href="#features" onClick={() => setMenuOpen(false)}>Services</a></li>
          <li><a href="#about" onClick={() => setMenuOpen(false)}>About</a></li>
          <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
          <li>
            <a href="tel:+919014937393" className="navbar-cta" onClick={() => setMenuOpen(false)}>
              📞 Call Now
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;